module.exports = __webpack_public_path__ + "img/makeping-logo1.ace14eba.png";